export { TriangleCorner } from './triangle-corner';
export type {
  TriangleCornerProps,
  TriangleCornerPosition,
} from './triangle-corner';
